import { useState, useRef } from "react";
import { FileDownload } from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';

interface ExportXmlButtonProps {
  disabled?: boolean;
  onExportDwa?(): void;
  onExportIsybau?(): void;
}

export default function ExportXmlButton({ disabled, onExportDwa, onExportIsybau }: ExportXmlButtonProps) {
  const { themeClass } = useThemeService();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);

  const handleOpen = () => {
    setAnchorEl(buttonRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div ref={buttonRef}>
      <Button
        id="export-xml"
        onClick={handleOpen}
        disabled={disabled}
        icon={{
          svg: FileDownload,
          textKey: "general.export.xml",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-mui"]),
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => { onExportIsybau?.(); handleClose(); }}>
          ISYBAU_2017-07
        </MenuItem>
        <MenuItem onClick={() => { onExportDwa?.(); handleClose(); }}>
          DWA-M150_04-2010
        </MenuItem>
      </Menu>
    </div>
  );
}
